import { GetterTree } from 'vuex'
import CaregiverState from './states'
import { State } from '@/store/store'

const getters: GetterTree<CaregiverState, State> = {
  headerLists: (state) => {
    return state.list.column
  },
  caregiverById: (state) => {
    return state.byId
  },
  itemLists: (state) => {
    return state.list.result
  },
  filterLists: (state) => {
    return state.list.defaultFilter
  },
  pagination: (state) => {
    const paginationLists = {
      itemCount: state.list.itemCount,
      page: state.list.page,
      pageCount: state.list.pageCount,
    }
    return paginationLists
  },
}

export default getters
